import React from 'react';
import { ThinkingOrb, type OrbState } from 'thinking-orbs';
import './ThinkingLabel.css';

export type ThinkingLabelVariant = 'thinking' | 'feedback';

const VARIANT_CONFIG: Record<
  ThinkingLabelVariant,
  { state: OrbState; subtext: string; ariaLabel: string; speed?: number }
> = {
  thinking: {
    state: 'working',
    subtext: 'Thinking',
    ariaLabel: 'Thinking',
  },
  feedback: {
    state: 'solving',
    subtext: 'Generating feedback',
    ariaLabel: 'Generating feedback',
    speed: 0.55,
  },
};

type ThinkingLabelProps = {
  variant?: ThinkingLabelVariant;
};

/** Large orb centered on the sphere; subtext below. */
export function ThinkingLabel({ variant = 'thinking' }: ThinkingLabelProps) {
  const { state, subtext, ariaLabel, speed } = VARIANT_CONFIG[variant];

  return (
    <div className="thinking-overlay-label" role="status" aria-live="polite">
      <div className="thinking-overlay-orb-wrap">
        <ThinkingOrb
          state={state}
          size={64}
          theme="dark"
          speed={speed}
          className="thinking-overlay-orb"
          aria-label={ariaLabel}
        />
      </div>
      <span className="thinking-overlay-subtext">{subtext}</span>
    </div>
  );
}
